import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <p
    className={`text-xs uppercase tracking-[0.3em] font-heading font-bold ${
      dark ? "text-peach" : "text-peach-dark"
    }`}
  >
    {children}
  </p>
);
